export default __webpack_public_path__ + "static/ag-grid-6712a8b137c7f2166ca8bd505518ae50.svg";